import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createEventAction } from '../../../redux/actions/eventsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import EventForm from '../forms/EventForm';

const CreatEventModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(
      createEventAction({
        title: data.title,
        startDate: dayjs(data.startDate).toISOString(),
        endDate: dayjs(data.endDate).toISOString(),
      }),
    );
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Створити подію'}
      loading={loading}
      onClose={onModalClose}
      body={<EventForm onSubmit={onSubmit} loading={loading} />}
      actionButton={
        <Button type={'submit'} disabled={loading} variant={'primary'} formId={'event-form'} children={'Зберегти'} />
      }
    />
  );
};

export default CreatEventModal;
